import('./gate.css')
export default function Gate(opts={}){
    BaseConstructor.call(this)
    let {container,gate,gate_id} = opts
    let elements = {}
    let context = this
    let current_status = gate.status == 'true' || gate.status == true

    this.generate = () =>{
        elements.button = this.createElement('div', `floodgate-button`, gate.id)
        this.updateButton()

        if(CAN_EDIT_PENHA){
            $(elements.button).on('click', () =>{
            current_status = !current_status
            this.updateButton()
            this.trigger('click', current_status)
        })
        }
        
        
        $(container).append(elements.button)
    }

    this.updateButton = () =>{
        $(elements.button).toggleClass('open', current_status)
    }
}

Gate.prototype = Object.create(BaseConstructor.prototype)